import ActiveBoardUser from "./active-board-user";
import style from "./board-users-presence.module.css";
import { SyncService } from "frontend/services/syncService";
import { RW } from "shared/datamodel/replicache-wrapper/mutators";
import { useEffect, useState } from "react";
import tracking from "frontend/tracking";
import consts from "shared/consts";
import MoreBoardActiveUsers from "./more-board-active-users";
import ProfileNew from "./profile-new";

interface BoardUsersPresenceProps {
  clientIds: string[];
  syncService: SyncService<RW> | null;
  followingClientId: string | null;
  onClientIdSelected?: (clientId: string) => void;
  isAnonymous?: boolean;
}

export default function BoardUsersPresence({
  isAnonymous,
  clientIds,
  syncService,
  followingClientId,
  onClientIdSelected,
}: BoardUsersPresenceProps) {
  const [clientIdsToShow, setClientIdsToShow] = useState<string[]>(
    clientIds.length > 4 ? clientIds.slice(0, 3) : clientIds
  );
  const [restClientIds, setRestClientIds] = useState<string[]>([]);

  const renderProfile = () => {
    if (isAnonymous) return null;

    return <ProfileNew isBoardHeader={true} syncService={syncService} />;
  };

  useEffect(() => {
    setClientIdsToShow(clientIds.length > 4 ? clientIds.slice(0, 3) : clientIds);
    setRestClientIds(clientIds.length > 4 ? clientIds.slice(3) : []);
  }, [clientIds.length]);

  useEffect(() => {
    tracking.trackEvent(
      consts.TRACKING_CATEGORY.USER_PRESENCE,
      "user_entered_canvas",
      "number of users",
      clientIds.length
    );
  }, []);

  return (
    <div className={style.container}>
      {restClientIds.length > 0 && (
        <MoreBoardActiveUsers
          syncService={syncService}
          clientIds={restClientIds}
          onClientIdSelected={onClientIdSelected}
          followingClientId={followingClientId}
        />
      )}
      {renderProfile()}
      {clientIdsToShow.map((id) => {
        return (
          <ActiveBoardUser
            key={id}
            clientID={id}
            syncService={syncService}
            onSelected={() => onClientIdSelected?.(id)}
            isFollowing={followingClientId === id}
          />
        );
      })}
    </div>
  );
}
